import { render, staticRenderFns } from "./recaptcha.vue?vue&type=template&id=8a3b4ee2"
import script from "./recaptcha.vue?vue&type=script&lang=js"
export * from "./recaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports